export default __webpack_public_path__ + "static/media/speaker-nilsen-montenegro.a6f8cf4c.jpg";